export const environment = {
  production: true,
  apiPrefix: 'management-api/v1/'
};
